import * as z from 'zod/mini';
import * as l from './UnitTokenTranslation.loc.js';
export const UnitToken = z.enum(Object.keys(l));
//# sourceMappingURL=UnitToken.js.map